// import { useState } from "react";

const hire = require("./images/hire.PNG");

const Hire = () => {
  // const [name, setName] = useState("[Type your name below]")

  // const nameHandle = (e) => {
  //   setName(e.target.value)
  //   console.log(name)
  // }

  // const getCurrentDate=(separator='/')=>{

  //   let newDate = new Date()
  //   let date = newDate.getDate();
  //   let month = newDate.getMonth() + 1;
  // //   let year = newDate.getFullYear();

  //   return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
  //   }

  return (
    <section className="py-14 bg-gray-100 mt-12 border-b shadow-lg" id="hire">
      <div className="max-w-screen-xl mx-auto px-4 gap-12 md:flex md:px-8">
        <div className="flex-1">
          <div className="flex flex-col max-w-lg justify-center">
            <p className="my-3 text-gray-800 text-center text-3xl font-extrabold sm:text-4xl">
              Let`s start cooperation!
            </p>
            <img
              fetchpriority="low"
              src={hire}
              className="rounded-lg shadow-2xl"
              alt="Handyman hire"
            />
          </div>
        </div>
        <div className="flex-1 mt-12 md:mt-0 ">
          <h3 className="mb-3 text-3xl flex items-center justify-between font-semibold text-gray-700">
            What is next?
          </h3>
          <p>
            We're excited to have you join our team! Please take a moment to
            fill out the registration form below. Your information will help us
            get to know you better and ensure a smooth onboarding process.
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSejrZ4k_Nf6jgHT2a3ycJ5yquG8kjOf81k37AKwebdg6cx6Cg/viewform?usp=sf_link"
            target="_blank"
            rel="noreferrer"
          >
            <button className="mt-5 mb-12 px-20 py-4 text-white font-bold text-lg duration-150 bg-green-600 rounded-full hover:bg-green-500 active:bg-green-700">
              Registration form
            </button>
          </a>
          {/* <p>
            If you have any questions or need assistance, don't hesitate to
            reach out to our team.
          </p>
          <a href="#contact_handyman">
            <button className="mt-5 mb-12 px-20 py-4 text-white font-bold text-lg duration-150 bg-sky-600 rounded-full hover:bg-sky-500 active:bg-sky-700">
              Contact us
            </button>
          </a> */}
          <h3 className="text-3xl font-bold">
            Thank you for choosing to work with us!
          </h3>
        </div>
        {/* <div className='flex-1 mt-12 md:mt-0 '>
              <h3
                                  className="mb-3 flex items-center justify-between font-semibold text-gray-700">
                                  Cooperation and Data Protection Agreement
                              </h3>
                  <ul className='space-y-4 divide-y select-none text-xs overflow-y-scroll  p-3 shadow h-[320px]'>
                  
                      
                          <li
                              className="pb-5"
                              >
                             
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                    This Cooperation and Data Protection Agreement ("Agreement") is entered into between "Elmarich LLC", hereinafter referred to as the "Company," and "{name}", hereinafter referred to as the "Handyman," collectively referred to as the "Parties."
                              </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                  1. Purpose of the Agreement
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                   The purpose of this Agreement is to establish the terms and conditions for the next cooperation between the Company and the Handyman, outlining their respective responsibilities, and ensuring the protection of sensitive data.
                              </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                  2. Terms of Cooperation
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                   2.1 The Handyman agrees to provide handyman services as agreed upon in previous discussions and as specified in work orders, contracts, or other written agreements.

<br/>2.2 The Company agrees to provide necessary support, access to tools and resources, and compensation as previously negotiated.
                              </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 3. Data Protection
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
3.1 The Parties recognize the importance of data protection and agree to handle all data, including customer information, with the utmost care and in compliance with applicable data protection laws.

<br/>3.2 The Handyman agrees to keep all customer data, business data, and any other sensitive information confidential and to use it only for the purposes of fulfilling their handyman duties.

<br/>3.3 The Handyman shall not disclose or share any sensitive information with third parties without the prior written consent of the Company.
                              </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 4. Ownership of Data
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>All customer data collected or generated during the cooperation shall remain the property of the Company. The Handyman has no rights to any customer data and shall not use it for any purpose other than the fulfillment of their duties.</p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 5. Termination
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                    Either party may terminate the cooperation with written notice. Upon termination, all customer data and information in the possession of the Handyman shall be promptly returned to the Company, and the Handyman's access to any systems or data shall be revoked.
                                  </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 6. Non-Disclosure
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                    The Handyman agrees to a non-disclosure obligation and shall not, at any time during or after the cooperation, disclose or use any confidential information of the Company, including customer data, without the Company's prior written consent.
                                  </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 7. Governing Law
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                    This Agreement shall be governed by and construed in accordance with the laws of [Your Jurisdiction].
                                  </p>
                          </li>

                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 8. Entire Agreement
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                    This Agreement constitutes the entire agreement between the Parties and supersedes all prior oral or written agreements, understandings, or representations.

                                  </p>
                          </li>
                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 9. Amendments
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                    No modification or amendment to this Agreement shall be effective unless it is in writing and signed by both Parties.

<br /><br />In witness whereof, the Parties hereto have executed this Agreement as of the date first above written.
                                  </p>
                          </li>
                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 Company Name: <span className="underline">Elmarich LLC</span>
                              </summary>
                          </li>
                          <li
                              className="py-5"
                              >
                              <summary
                                  className="flex items-center justify-between font-semibold text-gray-700">
                                 Handyman's Name: <span className="underline">{name}</span>
                              </summary>
                              <p
                                  
                                  className='mt-3 text-gray-600 leading-relaxed'>
                                   <span className="underline">Date: {getCurrentDate()}</span> 
                                    </p>
                          </li>
                      
                  </ul>
                  <div className="mt-5">
                    <input type="text" maxLength={40} onChange={e=> nameHandle(e)} placeholder="Type your full name" className="p-2 border rounded-md"/>
                  </div>
                  <div className="mt-5 flex">
                    <input type="checkbox" name="agree" />
                    <p className="px-2 text-sm font-semibold">I agree to the terms and conditions outlined in this Agreement.</p>
                  </div>
                  <a href="#hire">
                      <button
                          className="mt-5 px-20 py-3 text-white font-bold text-lg duration-150 bg-sky-600 rounded-lg hover:bg-sky-500 active:bg-sky-700"
                      >
                          Next
                      </button>
                      </a>
              </div> */}
      </div>
    </section>
  );
};

export default Hire;
